import { render, staticRenderFns } from "./PengalihanJalan.vue?vue&type=template&id=01722454&scoped=true"
import script from "./PengalihanJalan.vue?vue&type=script&lang=js"
export * from "./PengalihanJalan.vue?vue&type=script&lang=js"
import style0 from "./PengalihanJalan.vue?vue&type=style&index=0&id=01722454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01722454",
  null
  
)

export default component.exports